module.exports = __webpack_public_path__ + "static/media/logo5-grey.8859b2cd.png";